import { render } from "./Routelist.vue?vue&type=template&id=fbc4ab76"
import script from "./Routelist.vue?vue&type=script&lang=js"
export * from "./Routelist.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__